<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" :max-width="size" @click:outside="closeDialog">
      <v-card>
        <v-card-title class="py-2 white--text" :class="{ [theme]: true }">
          {{ title }}
        </v-card-title>
        <v-card-text class="py-4" v-html="message">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-show="type == 1">
            <v-btn :color="theme" text @click="closeDialog">
              Aceptar
            </v-btn>
          </div>
          <div v-show="type == 2">
            <v-btn :color="theme" text @click="accion">
              Aceptar
            </v-btn>
            <v-btn :color="theme" text @click="closeDialog">
              Cancelar
            </v-btn>
          </div>
          <div v-show="type == 3">
            <v-btn :color="theme" text @click="closeDialog">
              Cerrar
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      dialog: this.show,
    }
  },
  props: {
    title: {
      type: String,
      default: 'Super Exitos',
      require: true
    },
    type: {
      type: Number,
      default: 0,
      require: true
    },
    message: {
      type: String,
      default: '',
      require: true
    },
    show: {
      type: Boolean,
      default: false,
      require: true
    },
    size: {
      type: String,
      default: '400',
      require: true
    },
    theme: {
      type: String,
      default: 'yellow lighten-1',
      require: true
    },
    accion: {
      type: Function,
      default: () => false,
    },
    content: {
      type: String,
      default: null,
      require: false
    }
  }, methods: {
    closeDialog() {
      this.dialog = false
      this.$emit('click', false);
    }
  },
  beforeMount() {
  }
}
</script>